export default __webpack_public_path__ + "static/media/9.a353fde7.jpg";